import sessionUserReducer from "./sessionUserReducer";
import openSnackbarReducer from "./openSnackbarReducer";
import domainReducer from "./domainReducer";
import applicationReducer from "./applicationReducer";
import moduleReducer from "./moduleReducer";
import functionalityReducer from "./functionalityReducer";
import operationReducer from "./operationReducer";
import breadCrumbsReducer from "./breadCrumbsReducer";
import filterRequisitionReducer from "./filterRequisitionReducer";
import filterUserReducer from "./filterUserReducer";
import filterVacantReducer from "./filterVacantReducer";
import filterPublicVacantReducer from "./filterPublicVacantReducer";
import filterVacantRHReducer from "./filterVacantRHReducer";
import filterProfileReducer from "./filterProfileReducer";
import filterClausesReducer from "./filterClauseReducer";
import filterContractTypeReducer from "./filterContractTypesReducer";
import filterPostulatesReducer from "./filterPostulatesReducer";
import filterContractReducer from "./filterContractReducer";
import filterNotificationReducer from "./filterNotificationReducer";
import snackbarReducer from "./snackbarReducer";
import filterPermissionsReducer from "./filterPermissionsReducer";
import filterPermissionsFormReducer from "./filterPermissionsFormReducer";
import filterLaboratoryReducer from "./filterLaboratoryReducer";
import filterMedicalExamReducer from "./filterMedicalExamReducer";
import DisabledButtonContractReducer from "./disabledButtonContractReducer";
import filterCollectiveServiceReducer from './filterCollectiveServices';
import filterExamByCollectiveService from './filterExamByCollectiveService';
import filterPregnantReducer from './filterPregnantReducer';
import filterEndowmentDeliveryReducer from './filterEndowmentDeliveryReducer'
import filterRefundReducer from "./filterRefundReducer";
import filterCertificReducer from './filterCertificationreducer';
import DisabledBtnExamReducer from "./disableBtnExamReducer";
import DataEndowmentReducer from "./dataEndowmentReducer";

export const mainReducer = (
  {
    sessionUser,
    openSnackbar,
    domain,
    application,
    modul,
    functionality,
    operation,
    breadCrumb,
    filterRequisition,
    filterUser,
    filterVacant,
    filterPublicVacant,
    filterVacantRH,
    filterProfile,
    filterClauses,
    filterContractType,
    filterPostulate,
    filterContract,
    filterNotification,
    snackbarMessage,
    filterPermissions,
    filterPermissionsForm,
    filterLaboratory,
    filterMedicalExam,
    isDisableBtnContract,
    filterColService,
    filterExamByService,
    filterPregnant,
    filterEndowmentDelivery,
    filterRefundByRecomendation,
    filterCertificateReducer,
    isDisabledBtnExam,
    dataEndowment
  },
  action
) => {
  return {
    application: applicationReducer(application, action),
    modul: moduleReducer(modul, action),
    domain: domainReducer(domain, action),
    sessionUser: sessionUserReducer(sessionUser, action),
    openSnackbar: openSnackbarReducer(openSnackbar, action),
    functionality: functionalityReducer(functionality, action),
    operation: operationReducer(operation, action),
    breadCrumb: breadCrumbsReducer(breadCrumb, action),
    filterRequisition: filterRequisitionReducer(filterRequisition, action),
    filterUser: filterUserReducer(filterUser, action),
    filterVacant: filterVacantReducer(filterVacant, action),
    filterPublicVacant: filterPublicVacantReducer(filterPublicVacant, action),
    filterVacantRH: filterVacantRHReducer(filterVacantRH, action),
    filterProfile: filterProfileReducer(filterProfile, action),
    filterClauses: filterClausesReducer(filterClauses, action),
    filterContractType: filterContractTypeReducer(filterContractType, action),
    filterPostulate: filterPostulatesReducer(filterPostulate, action),
    filterContract: filterContractReducer(filterContract, action),
    filterNotification:filterNotificationReducer(filterNotification,action),
    snackbarMessage: snackbarReducer(snackbarMessage, action),
    filterPermissions: filterPermissionsReducer(filterPermissions, action),
    filterPermissionsForm: filterPermissionsFormReducer(filterPermissionsForm, action),
    filterLaboratory: filterLaboratoryReducer(filterLaboratory, action),
    filterMedicalExam: filterMedicalExamReducer(filterMedicalExam, action),
    isDisableBtnContract: DisabledButtonContractReducer(isDisableBtnContract, action),
    filterColService: filterCollectiveServiceReducer(filterColService, action),
    filterExamByService: filterExamByCollectiveService(filterExamByService, action),
    filterPregnant: filterPregnantReducer(filterPregnant, action),
    filterEndowmentDelivery: filterEndowmentDeliveryReducer(filterEndowmentDelivery, action),
    filterRefundByRecomendation: filterRefundReducer(filterRefundByRecomendation, action),
    filterCertificateReducer: filterCertificReducer(filterCertificateReducer, action),
    isDisabledBtnExam: DisabledBtnExamReducer(isDisabledBtnExam, action),
    dataEndowment: DataEndowmentReducer(dataEndowment, action),
  };
};
